export function imageDimensions(file: any): Promise<{ width: number; height: number }> {
  return new Promise(function (resolved, _rejected) {
    const img = new Image()
    img.onload = function () {
      resolved({ width: img.width, height: img.height })
    }
    img.src = file
  })
}
